function keysOf(obj) {
  return obj ? Object.keys(obj).map((k) => String(k)) : [];
}
function nonNullable(val) {
  return val !== null;
}
export {
  keysOf,
  nonNullable
};
//# sourceMappingURL=types.js.map
